import React from 'react'
import PropTypes from 'prop-types'
import Dropdown from '@vtex/styleguide/lib/Dropdown'
import isEmpty from 'lodash/isEmpty'
import uniqBy from 'lodash/uniqBy'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import {
  sendEvent,
  messages,
  getChannel,
  Subscriber,
} from '@/checkout-instore-legacy/utils/device/communication'
import { byFilterConfig } from '../../utils'

import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'

class ListPrinters extends React.Component {
  state = {
    printers: [],
    lastMessageId: null,
    selectedPrinter: '',
  }

  componentDidMount() {
    if (this.props.device.defaultPrinter) {
      const { printers } = this.state
      const { device } = this.props
      this.setState({
        printers: [...printers, device.defaultPrinter],
        selectedPrinter: this.formatLabel(device.defaultPrinter),
      })
    }
  }

  sendGetPrintersEvent = () => {
    const channel = getChannel()
    const emitter = this.props.device
    const message = messages.getPrintersMessage.build(emitter)
    sendEvent(channel, message)
  }

  addPrinters = (messageFromBroker) => {
    const { type, messageId } = messageFromBroker

    if (type !== 'send-printers' || this.state.lastMessageId === messageId) {
      return null
    }

    const { printers } = this.state

    const {
      payload: { printers: printersFromBroker },
      emitter,
    } = messageFromBroker

    const { printingConfig } = getInstoreConfig()
    const printersWithDevice = printersFromBroker
      .filter(
        byFilterConfig(
          printingConfig ? printingConfig.printersFilter : undefined
        )
      )
      .map((printer) => {
        return {
          ...printer,
          device: {
            deviceName: emitter.deviceName,
            deviceId: emitter.deviceId,
          },
        }
      })

    this.setState({
      printers: [
        ...printers,
        ...printersWithDevice,
        {
          device: emitter,
        },
      ],
      lastMessageId: messageId,
    })

    return null
  }

  getOptions = () => {
    const { printers } = this.state

    if (isEmpty(printers)) return []
    const mappedPrinters = uniqBy(
      printers.map((printer) => {
        return {
          label: this.formatLabel(printer),
          value: this.formatLabel(printer),
        }
      }),
      'value'
    )
    const sortedByNamePrinters = mappedPrinters.sort(
      (printer, nextPrinter) => printer.label > nextPrinter.label
    )

    return sortedByNamePrinters
  }

  formatLabel = (printer) => {
    const { intl } = this.props

    const printerName =
      printer && printer.name
        ? printer.name
        : intl.formatMessage({
            id: 'defaultPrinter',
          })

    const deviceName =
      printer && printer.device && printer.device.deviceName
        ? ` - ${printer.device.deviceName}`
        : ''

    return `${printerName}${deviceName}`
  }

  handleChange = (e, value) => {
    const { printers } = this.state

    if (!value) return

    const printer = printers.find(
      (printer) => this.formatLabel(printer) === value
    )

    this.props.onSelectPrinter(printer)

    this.setState({ selectedPrinter: value })
  }

  componentDidUpdate(prevProps) {
    const { device, credentials } = this.props
    if (
      device &&
      prevProps.device &&
      prevProps.device.defaultPrinter !== device.defaultPrinter
    ) {
      this.setState({
        selectedPrinter: this.formatLabel(device.defaultPrinter),
      })
    }
    if (
      prevProps.credentials &&
      credentials &&
      prevProps.credentials.success !== credentials.success
    ) {
      this.sendGetPrintersEvent()
      this.setState({
        printers: [device.defaultPrinter],
      })
    }
  }

  handleOnOpen = () => {
    this.sendGetPrintersEvent()
  }

  render() {
    const channel = getChannel()
    const { intl } = this.props
    const { selectedPrinter } = this.state

    return (
      <React.Fragment>
        <Subscriber channel={channel} onOpen={this.handleOnOpen}>
          {(message) => this.addPrinters(message)}
        </Subscriber>
        <Dropdown
          options={this.getOptions()}
          onChange={this.handleChange}
          value={selectedPrinter}
          label={intl.formatMessage({
            id: 'defaultPrinter',
          })}
          placeholder={intl.formatMessage({
            id: 'selectPrinter',
          })}
        />
      </React.Fragment>
    )
  }
}

ListPrinters.propTypes = {
  device: PropTypes.shape({
    deviceId: PropTypes.string,
    deviceName: PropTypes.string,
    defaultPrinter: PropTypes.shape({
      name: PropTypes.string,
      device: PropTypes.shape({
        deviceId: PropTypes.string.isRequired,
        deviceName: PropTypes.string,
      }),
    }),
  }).isRequired,
  onSelectPrinter: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  credentials: PropTypes.shape({
    success: PropTypes.bool.isRequired,
  }),
}
export default ListPrinters
